import { UnitLabelType, UnitUsageRange } from "@asd/customer-portal-api";
import { Theme } from "@mui/material";

export const UNIT_USAGE_OPTIONS = [
  {
    id: UnitUsageRange.Under60,
    maxValue: 60,
    includeMax: false,
    label: "< 60%",
    backgroundColor: (theme: Theme) => theme.palette.unitUsage[UnitUsageRange.Under60],
  },
  {
    id: UnitUsageRange.Range60to80,
    minValue: 60,
    maxValue: 80,
    label: "60% - 80%",
    backgroundColor: (theme: Theme) => theme.palette.unitUsage[UnitUsageRange.Range60to80],
  },
  {
    id: UnitUsageRange.Range80to100,
    minValue: 80,
    maxValue: 100,
    label: "81% - 100%",
    backgroundColor: (theme: Theme) => theme.palette.unitUsage[UnitUsageRange.Range80to100],
  },
  {
    id: UnitUsageRange.Over100,
    minValue: 100,
    label: "> 100%",
    backgroundColor: (theme: Theme) => theme.palette.unitUsage[UnitUsageRange.Over100],
  },
];

export const getUnitUsageColor = (value: number, theme: Theme) =>
  UNIT_USAGE_OPTIONS.find(
    ({ maxValue = Infinity, minValue = -1, includeMax = true }) => value >= minValue && (includeMax ? value <= maxValue : value < maxValue),
  )?.backgroundColor ?? theme.palette.primary.main;

// Formats a value with a "$" prefix and 2 decimals for dollars, otherwise the raw value (no unit suffix)
export const getUnitValueText = (value: number | string | null | undefined, unitLabel: string) => {
  const isUnitLabelDollar = unitLabel === UnitLabelType.Dollars;
  return `${isUnitLabelDollar ? "$" : ""}${isUnitLabelDollar ? Number(value).toFixed(2) : value}`;
};

// Formats a value with its unit label (pluralized unless pluralizeValue is 1); dollars get no suffix.
// pluralizeValue defaults to value, but can differ when the displayed value is pre-formatted
export const getUnitValueLabel = (value: number | string | null | undefined, unitLabel: string, pluralizeValue: unknown = value) => {
  const isUnitLabelDollar = unitLabel === UnitLabelType.Dollars;
  return `${getUnitValueText(value, unitLabel)}${!isUnitLabelDollar && !!unitLabel.length ? ` ${unitLabel}${pluralizeValue !== 1 ? "s" : ""}` : ""}`;
};

const ADDITIONAL_EMPLOYER_EXPENSE_REGEX = /^(Additional Employer Expenses?|AEE)$/i;
export const isAdditionalEmployerExpense = (description: string | null | undefined) =>
  !!description && ADDITIONAL_EMPLOYER_EXPENSE_REGEX.test(description);
